<template>
    <div>
        <rkm-table
            :fields="fields"
            :items="prestador.exames"
            sort-by="nome"
        >
            <template v-slot:cell(actions)="{ item }">
                <rkm-button
                    @click="$refs.ModalObservacao.open(item)"
                    color="info"
                    small
                    title="Observações"
                >
                    <rkm-icon icon="comment" />
                </rkm-button>

                <rkm-button
                    :color="item.ativo ? 'dark' : 'success'"
                    :title="item.ativo ? 'Desativar' : 'Ativar'"
                    @click="item.ativo = !item.ativo"
                    small
                >
                    <rkm-icon :icon="item.ativo ? 'ban' : 'check-circle'" />
                </rkm-button>

                <rkm-button
                    @click="destroy(item)"
                    color="danger"
                    small
                    title="Excluir"
                >
                    <rkm-icon icon="trash" />
                </rkm-button>
            </template>
        </rkm-table>

        <ModalObservacao ref="ModalObservacao" />
    </div>
</template>

<script>
// Components.
import ModalObservacao from './components/observacao/Modal'

// Mixins.
import { formats } from '@/mixins'

export default {
    components: { ModalObservacao },
    data() {

        return {
            fields: [
                {
                    key: 'codigo',
                    label: 'Código',
                    formatter: codigo => codigo ? this.formatProcedimento(codigo) : '-',
                    sortable: true,
                    class: 'col-min',
                },
                { key: 'nome', label: 'Nome', sortable: true },
                { key: 'grupoNome', label: 'Grupo', sortable: true },
                { key: 'actions', label: 'Ações', class: 'col-min text-center' },
            ],
        }
    },
    methods: {
        destroy(exame) {

            this.showDeleteConfirmation(
                'Deseja realmente excluir o exame?',
                async () => this.prestador.exames.splice(this.prestador.exames.indexOf(exame), 1)
            )
        }
    },
    mixins: [formats],
    props: {
        prestador: { type: Object, required: true },
    }
}
</script>